/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("BufferedConsoleLogProvider", ["LogProviderBase", "ConsoleLogProvider"], function (context, cls) {
  /**
   * @class BufferedConsoleLogProvider
   * @memberOf classes
   * @extends classes.LogProviderBase
   */
  class BufferedConsoleLogProvider extends cls.LogProviderBase /** @lends classes.BufferedConsoleLogProvider.prototype */ {
    constructor() {
      super();
      this.throttle = 100;
      this.buffer = [];
      this.console = new cls.ConsoleLogProvider();
      this.currentLevel = "none";
    }

    flush(force) {
      if (this.buffer.length) {
        if (force || this.buffer.length >= this.throttle) {
          this.console.getLogger()[this.currentLevel](this.buffer.join("\n"));
          this.buffer.length = 0;
        }
      }
    }

    getLogger() {
      const result = {};
      const levels = context.LogService.levels;
      for (const element of levels) {
        const item = element;
        result[item] = this._loggerMethod.bind(this, item);
      }
      return result;
    }

    _loggerMethod(level, arg) {
      if (level !== "all") {
        this.flush(this.currentLevel !== level);
        this.currentLevel = level;
        this.buffer.push(arg);
      }
    }
  }

  cls.BufferedConsoleLogProvider = BufferedConsoleLogProvider;
});
